import { ROUTES, ROUTE_PARAMS, PREDICT_PRODUCT_SLUG, QUERY_PARAMS } from '../../app-core';
import { getProductRoute } from '../../organisations';
import { interpolatePathParams, joinRouteMatchUrl } from '../../path';

// ***************
// * Route paths *
// ***************

export const getDashboardsRoutePath = () => {
  const base = getProductRoute();
  return joinRouteMatchUrl('', base, ROUTES.DASHBOARDS);
};

// *************
// * Page URLs *
// *************

export const getDashboardsUrl = (workspaceId: string, organisationId: string): string =>
  interpolatePathParams(getDashboardsRoutePath(), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG
  });

export const getDashboardsPerformanceDashboardsUrl = (
  workspaceId: string,
  organisationId: string,
  dashboardId?: string
): string => {
  const baseUrl = interpolatePathParams(
    joinRouteMatchUrl('', getProductRoute(), ROUTES.DASHBOARDS, ROUTES.PERFORMANCE_DASHBOARDS),
    {
      [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
      [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
      [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG
    }
  );

  return dashboardId ? `${baseUrl}?${QUERY_PARAMS.DASH_ID}=${dashboardId}` : baseUrl;
};

export const getDashboardsDashboardsListUrl = (workspaceId: string, organisationId: string): string =>
  interpolatePathParams(joinRouteMatchUrl('', getProductRoute(), ROUTES.DASHBOARDS, ROUTES.DASHBOARDS_LIST), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG
  });

export const getDashboardsTemplatesUrl = (workspaceId: string, organisationId: string): string =>
  interpolatePathParams(joinRouteMatchUrl('', getProductRoute(), ROUTES.DASHBOARDS, ROUTES.DASHBOARD_TEMPLATES), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.PRODUCT_SLUG]: PREDICT_PRODUCT_SLUG
  });
